import { render, staticRenderFns } from "./plantao-view.vue?vue&type=template&id=218fee1d"
import script from "./plantao-view.vue?vue&type=script&lang=js"
export * from "./plantao-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports